class FostrCartItems extends CartDrawerItems {
    constructor() {
        super();
      
        fetch(routes.cart_url + '.json').then(res => res.json()).then(data => {
          const items = data.items
          const giftWrapProduct = data.items.filter(item => item.id === giftwrapVariantId)
          const line = data.items.findIndex(item => item.variant_id === giftwrapVariantId) + 1
          const sections = document.querySelector('cart-drawer').getSectionsToRender()

          if (items.length <= giftWrapProduct.length) {
            const body = JSON.stringify({
              line,
              quantity: 0,
              sections: sections.map((section) => section.section ? section.section : section.id),
              sections_url: window.location.pathname
            })
            fetch(routes.cart_change_url + '.js', { ...fetchConfig(), body }).then(res => res.text()).then(data => {
              const cart = document.querySelector('cart-drawer')
              const parsedState = JSON.parse(data)
              cart.renderContents(parsedState)
            })
          }
        });

        document.querySelectorAll('.message-toggle').forEach((closeButton) => {
          closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            let cartMessage = document.querySelector('cart-drawer .message-content');
            let cartDrawer = document.querySelector('cart-drawer .message-drawer');
            let cartWrapper = document.querySelector('#CartDrawer .drawer__inner');

            if(cartMessage.classList.contains('open')){
              cartWrapper.classList.remove('prevent');
              cartMessage.classList.remove('open');
              cartDrawer.classList.remove('active');
            }else{
              cartWrapper.classList.add('prevent');
              cartMessage.classList.add('open');
              cartDrawer.classList.add('active');
            }
          });
        });

        const textarea = document.getElementById("personalised-message");
        let charsCountMessage = document.getElementById("count-user");

        let maxLength = 2000;
        if( textarea ) {
          maxLength = textarea.getAttribute("maxlength");
          charsCountMessage.innerHTML = textarea.value.length;

          textarea.addEventListener("input", event => {
              const target = event.currentTarget;
              const currentLength = target.value.length;
              charsCountMessage.innerHTML = currentLength;
              if (currentLength >= maxLength) {
                  charsCountMessage.innerHTML = maxLength;
              }
          });

          textarea.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
          }, 300))
        }


        const giftwrapOrder = document.querySelector('.giftwrap-order-prop');

        if( giftwrapOrder ) {
          giftwrapOrder.addEventListener('change', (event) => {
            this.addOrderGiftwrap(event.target.checked, event);
          });
        }

        document.querySelectorAll('.wrap-toggle').forEach((closeButton) => {
          closeButton.addEventListener('click', debounce((event) => {
            let cartWrap = document.querySelector('cart-drawer .giftwrap-content');
            let cartwrapDrawer = document.querySelector('cart-drawer .giftwrap-drawer');
            let cartWrapper = document.querySelector('#CartDrawer .drawer__inner');
  
            if(cartWrap.classList.contains('open')){
              cartWrapper.classList.remove('prevent');
              cartWrap.classList.remove('open');
              cartwrapDrawer.classList.remove('active');
            }else{
              cartWrapper.classList.add('prevent');
              cartWrap.classList.add('open');
              cartwrapDrawer.classList.add('active');
            }
          }, 300));
        });

        const giftWrapTextField = document.getElementById('personalised-message')
        const giftWrapCheckbox = document.getElementById('CartDrawer-order-is-gift-checkbox')

        fetch(routes.cart_url + '.json').then(res => res.json()).then(data => {
          const giftwrapItem = data.items.find(item => item.variant_id === giftwrapVariantId)
          if(giftwrapItem) {
            giftWrapCheckbox.checked = true
            document.querySelector('.gift-wrap-accordion details').open = true
            if(giftwrapItem.properties[giftwrapItemPropertyName]) giftWrapTextField.value = giftwrapItem.properties[giftwrapItemPropertyName]
          }
          

          giftWrapCheckbox.addEventListener('change', this.handleGiftwrap)
          giftWrapTextField.addEventListener('input', debounce(this.handleGiftwrap, 300))
        })
      }

      onChange(event) {
        if(event.target.className == 'giftwrap-prop'){ 
          this.addItemGiftwrap(event.target.dataset.index, event.target.checked, event);
        }else{
          this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
        }
      }

      addItemGiftwrap(line, value, event) {
        var wrapit = 'No'
        if(value == true){
          wrapit = 'Yes'
        }
        const body = JSON.stringify({
          line,
          'properties': { '_gift_wrap': wrapit },
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });

        //this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
        [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            let currentTarget = event.target.name;
            let currentLabel = document.querySelector('label[for="'+ currentTarget +'"]');
            let currentCTA = currentLabel.innerText;
            let addCTA = currentLabel.dataset.add;
            let removeCTA = currentLabel.dataset.remove;

            if(currentCTA == addCTA){
              currentLabel.innerText = removeCTA;
            }else{
              currentLabel.innerText = addCTA;
            }
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          }).catch(() => {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        });
          
      }

      onGiftWrapCommentChange() {
        // Debounced call to Shopify API to prevent spamming
        if(this.commentChangeTimeout) clearTimeout(this.commentChangeTimeout)
        this.commentChangeTimeout = setTimeout(this.handleGiftwrap(this), 500)
      }

      handleGiftwrap() {
        const giftWrapTextField = document.getElementById('personalised-message')
        const giftWrapCheckbox = document.getElementById('CartDrawer-order-is-gift-checkbox')
        const message = giftWrapTextField.value | 'Gift Wrapped'
        const value = giftWrapCheckbox.checked
        const sections = document.querySelector('cart-drawer').getSectionsToRender()

        
        fetch(routes.cart_url + '.json').then(res => res.json()).then(data => {
          const giftwrapItem = data.items.find(item => item.variant_id === giftwrapVariantId)
          const line = data.items.findIndex(item => item.variant_id === giftwrapVariantId) + 1
          
          if(!value && giftwrapItem) {
            // Step 1 - Remove gift if already exists and value false
            const body = JSON.stringify({
              line,
              quantity: 0,
              sections: sections.map((section) => section.section ? section.section : section.id),
              sections_url: window.location.pathname
            })
            fetch(routes.cart_change_url + '.js', { ...fetchConfig(), body }).then(res => res.text()).then(data => {
              const cart = document.querySelector('cart-drawer')
              const parsedState = JSON.parse(data)
              cart.renderContents(parsedState)
            })
          } else if(value && !giftwrapItem) {
            // Step 2 - Add gift if doesn't exist and value true
            const body = JSON.stringify({
              items: [{
                id: giftwrapVariantId,
                quantity: 1, 
                properties: {
                  [giftwrapItemPropertyName]: message
                }
              }],
              sections: sections.map((section) => section.section ? section.section : section.id),
              sections_url: window.location.pathname
            })
            fetch(routes.cart_add_url, { ...fetchConfig(), body }).then(res => res.text()).then(data => {
              const cart = document.querySelector('cart-drawer')
              const parsedState = JSON.parse(data)
              cart.renderContents(parsedState)
            })
          } else if(giftwrapItem && giftwrapItem.properties[giftwrapItemPropertyName] !== message) {
            // Step 3 - Update message if it's changed
            const body = JSON.stringify({
              line,
              quantity: 1,
              properties: {
                ...giftwrapItem.properties,
                [giftwrapItemPropertyName]: message
              },
              sections: sections.map((section) => section.section ? section.section : section.id),
              sections_url: window.location.pathname
            })
            fetch(routes.cart_change_url + '.js', { ...fetchConfig(), body }).then(res => res.text()).then(data => {
              const cart = document.querySelector('cart-drawer')
              const parsedState = JSON.parse(data)
              cart.renderContents(parsedState)
            })
          }
        })
      }

      addOrderGiftwrap(value, event) {
        var wrapit = 'No'
        if(value == true){
          wrapit = 'Yes'
        }
        const body = JSON.stringify({
          'attributes': { 'Gift Wrapping': wrapit },
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });


        /*
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
        [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
        */
        

        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            let currentTarget = event.target.id;
            let currentLabel = document.querySelector('label[for="'+ currentTarget +'"]');
            let wrapLabel = document.querySelector('.wrap-update'); 
            let currentCTA = currentLabel.innerText;
            let addCTA = currentLabel.dataset.add;
            let removeCTA = currentLabel.dataset.remove;
            if(currentCTA == addCTA){
              currentLabel.innerText = removeCTA;
              wrapLabel.innerText = removeCTA;
            }else{
              currentLabel.innerText = addCTA;
              wrapLabel.innerText = addCTA;
            }
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          }).catch(() => {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        });
          
      }

}

customElements.define('cart-drawer-items', FostrCartItems);
